import { Component, Vue } from "vue-property-decorator";
import { ToolConfigGetters } from "@/store/modules/toolConfig";
import { WBStoreGetters } from "./store/getters";
import { AllState } from "./store/AllState";
import WhiteboardControllerInterface from "./wbcontroller/types/WhiteboardControllerInterface";
import { UserGetters } from "./store/modules/user";
import { ReportedGetters } from "./store/modules/reported";
import { ModalGetters } from "./store/modules/modal";

@Component
export default class WBComponent extends Vue {
  get state(): AllState {
    return this.$store.state;
  }

  get getters(): WBStoreGetters {
    return this.$store.getters as WBStoreGetters & {
      modal: ModalGetters;
      reported: ReportedGetters;
      toolConfig: ToolConfigGetters;
      user: UserGetters;
    };
  }

  get wbcontroller(): WhiteboardControllerInterface | undefined {
    return this.getters.wbcontroller;
  }
}
